<template>
  <s-table
      ref="table"
      :columns="columns"
      :data="loadData"
      :customRow="customRow"
      :rowKey="record => record.id"
      :pagination="{ showTotal: (total) => `共 ${total} 条` }"
  >
  </s-table>
</template>
<script>
import qs from 'qs'
import moment from 'moment'
import STable from '@/components/Table'
import { QueryExpertWorkRecordList } from '@/epp/expertmain/expertFees/api/ExpertReasonApi'
import { expertFlagEnum } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'

const columns = [
  {
    title: '项目申请时间',
    width: '200px',
    dataIndex: 'applyDate',
    customRender: (text, record) => {
      return text && moment(text).format('YYYY年MM月DD日')
    }
  },
  {
    title: '项目名称',
    dataIndex: 'projectName',
    ellipsis:true,
    align: 'left',
  },
  {
    title: '项目编号',
    dataIndex: 'projectCode',
    align: 'center',
  },
  {
    title: '专家名称',
    width: '200px',
    dataIndex: 'expertName'
  },
  {
    title: '抽取方式',
    width: '200px',
    dataIndex: 'extractionMethod'
  },
  {
    title: '抽取时间',
    width: '200px',
    dataIndex: 'addDate',
    customRender: (text, record) => {
      return text && moment(text).format('YYYY年MM月DD日 HH:mm')
    }
  },
]
export default {
  name: 'expertFeesSTable',
  components: {
    STable
  },
  props: {
    expertId:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      columns,
      user: this.$ls.get('user'),
      ifOperation: false, // 当触发操作列 的 按钮时，不触发详情onView
      payLoading: false,
      total: null,
      customRow: (record, index) => {
        return {
          on: {
            click: () => {
              // 当触发操作列 的 按钮时，不触发详情onView
              if (this.ifOperation) {
                return
              }
              this.$router.push({
                path: '/selectExpertApply/view?id=' + record.parentId
              })
            }
          }
        }
      },
      loadData: (parameter) => {
        const data = {
          ...parameter,
          expertId: this.expertId
        }
        return QueryExpertWorkRecordList(data)
      }
    }
  },
  watch: {
    expertId (val) {
      this.$refs.table.refresh()
    }
  },
  methods: {
    handleVisibleChange (visible) {
      this.ifOperation = true
      if (!visible) {
        this.ifOperation = false
      }
    },
    onPay (record) {
      this.ifOperation = true
      this.payLoading = true
      this.updateFeesState(record, '1')
    },
    onRevocation (record) {
      this.ifOperation = true
      this.payLoading = true
      this.updateFeesState(record, '0')
    },
    // 修改支付状态的 请求方法
    updateFeesState (record, feesState) {
      const that = this

      let data = {}
      data.id = record.id
      data.feesState = feesState

      that.$http.post('/api/1/expertmain/selectExpertFeedback/update_skipNullValue.json', qs.stringify(data)).then(
          res => {
            if (res.code !== 200) {
              return
            }
            that.$message.success('操作成功！')
            that.$refs.table.refresh()
          }
      ).finally(function () {
        that.ifOperation = false
        that.payLoading = false
      })
    }
  }
}
</script>
